/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PlacementDto
 */
export interface PlacementDto {
    /**
     * 
     * @type {number}
     * @memberof PlacementDto
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof PlacementDto
     */
    name: string;
}

/**
 * Check if a given object implements the PlacementDto interface.
 */
export function instanceOfPlacementDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function PlacementDtoFromJSON(json: any): PlacementDto {
    return PlacementDtoFromJSONTyped(json, false);
}

export function PlacementDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlacementDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function PlacementDtoToJSON(value?: PlacementDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

